import { createSlice } from "@reduxjs/toolkit";
import { useAppSelector } from "../store";

interface transactionsSliceInterface {
  data: [];
  status: "idle";
  error: null;
  recentTransaction: {
    ticker: string;
    date: string;
  };
  notes: {
    id: string;
    note: string;
  }[];
}

const initialState: transactionsSliceInterface = {
  data: [],
  status: "idle",
  error: null,
  recentTransaction: {
    ticker: "",
    date: "",
  },
  notes: [
    {
      id: "",
      note: "",
    },
  ],
};

const transactionsSlice = createSlice({
  name: "transactions",
  initialState,
  reducers: {
    getMobileDataWithFilter: (state, action) => {
      state = action.payload;
    },
    setMostRecentTransaction: (state, action) => {
      state.recentTransaction = action.payload;
    },
    addTransactionNote: (state, action) => {
      const { id, note } = action.payload;
      const index = state.notes.findIndex((note) => note.id === id);
      if (index !== -1) {
        // If the element with the matching ID exists, update it
        state.notes[index] = { ...state.notes[index], note };
      } else {
        // If the element with the matching ID does not exist, push a new element
        state.notes.push({ id, note });
      }
    },
  },
});

export default transactionsSlice;

export const { getMobileDataWithFilter, setMostRecentTransaction, addTransactionNote } =
  transactionsSlice.actions;

export const useTransactionSlice = () => useAppSelector((state) => state.transactions);
